import React from 'react';
import JamProfileCreate from '../components/Profile/JamProfileCreate/JamProfileCreate';

export const CreateJamProfilePage: React.FC = () => {
  return <JamProfileCreate />;
};
